import { Airport, PassengersSegmentedCount } from '@ibe/models';
export interface InspirationDestination {
	type: 'theme' | 'anywhere';
	value: Object;
	code?: any;
	weakFlight?: boolean;
}

export class RouteTrip {
	departure: Airport | InspirationDestination;
	arrival: Airport | InspirationDestination;
	date: Date;
}

export class Stopover {
	city: string;
	when: 'outbound' | 'inbound';
	days: number;
	id: string;
}

export class Tripfinder {
	anywhere: boolean;
	regions: number;
}

export class IsStopover {
	isStopover: boolean;
}

/**
 * State of the Mini IBE
 *
 * @export
 * @class State
 */
export class State {
	loading: boolean;
	flight_type: 'flights' | 'stopover' | 'corporate';
	route_type: 'R' | 'O' | 'M';
	current_seach_route: number;
	activeInput: string;
	search_routes: Array<RouteTrip>;
	passengers: PassengersSegmentedCount;
	stopovers: Array<Stopover>;
	tripfinder: Array<Tripfinder>;
	rangeDates: Array<Date>;
	dateOne: Date;
	isStopover: boolean;
	deeplinkParams?: any;
}

export const initialState: State = {
	loading: false,
	current_seach_route: 0,
	activeInput: null,
	flight_type: 'flights',
	/*
	route_type: 'round trip',
	search_routes: [{
		departure: {
			name: 'LISBOA',
			code: 'LIS',
			label: 'LISBOA',
			direct: null,
			location: {
				city: 'Lisbon',
				cityName: 'LIS',
				alias: `Lisbon, Portugal`,
				country: 'Portugal',
				countryName: 'PT'
			}
		},
		arrival: null,
		date: null
	}],
	*/
	route_type: 'R',
	search_routes: [{
		departure: null,
		arrival: null,
		date: null
	}],
	passengers: {
		children: 0,
		youngAdults: 0,
		adults: 1,
		infants: 0
	},
	stopovers: [],
	tripfinder: [],
	rangeDates: [],
	dateOne: null,
	isStopover: false,
	deeplinkParams: {},
};
